import { z } from 'zod';
/**
 * Mate-in-2 — chess tactics.
 *
 * White to move, and there is a move that forces checkmate within two moves
 * against any Black defence. Find White's first move.
 *
 * Interaction: the player selects a from-square then a to-square. The server
 * validates the move is legal and that it forces mate in 2 (it searches every
 * Black reply and every White follow-up). A move that doesn't force mate is a
 * wrong attempt — scored, not rejected.
 *
 * Squares are 0..63, a8=0 ... h1=63 (rank-major from Black's back rank), so the
 * board renders top-to-bottom as White sees it flipped. See the component.
 */
export const ChessMoveEvent = z.object({
    type: z.literal('move'),
    from: z.number().int().min(0).max(63),
    to: z.number().int().min(0).max(63),
    /** Promotion piece if a pawn reaches the last rank. Rare in these puzzles. */
    promo: z.enum(['q', 'r', 'b', 'n']).optional(),
});
export const ChessEvent = z.discriminatedUnion('type', [ChessMoveEvent]);
//# sourceMappingURL=chess-mate.js.map